import React from "react"
import { Translate } from "utils/i18n-shim"
import { Grid } from "@mui/material"

import { MainCard } from "shared/ui/berry-jass"
import { CampaignTags } from "entities/tag"

const TagsSectionComponent = ({ order, japCustomerId }) => {
  return (
    <MainCard
      title={<Translate value="campaigns.campaign-tags" />}
      contentSX={{ p: 2 }}
    >
      <Grid container alignItems="center" columnSpacing={2} rowSpacing={2}>
        <Grid item xs={12}>
          <CampaignTags
            japCustomerId={japCustomerId}
            atsTags={order.ats_tags}
          />
        </Grid>
      </Grid>
    </MainCard>
  )
}

export const TagsSection = React.memo(TagsSectionComponent)
